import React from "react";
import AdminLayout from "../../Components/Layout/AdminLayout";
import { Outlet } from "react-router-dom";

export default function AdminDashboard() {
  return (
    <>
      <AdminLayout />
      <Outlet />
    </>
  );
}
